import { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import dayjs from 'dayjs'
import {
  FULLSCREEN_POST_ID_KEY,
  FULLSCREEN_POST_KEY,
  LAST_OPENED_POST_DATE_KEY,
} from '../WeekViewV2/useOpenLastFullscreenPost'

export const useFullscreenBackNavigation = ({
  onClose,
  currentItemDate,
}: {
  onClose: () => void
  currentItemDate: string | null
}) => {
  const history = useHistory()
  const { search } = useLocation()

  const handleClose = useCallback(() => {
    const queryParams = new URLSearchParams(search)

    queryParams.delete(FULLSCREEN_POST_ID_KEY)
    queryParams.set(LAST_OPENED_POST_DATE_KEY, dayjs(currentItemDate).format('YYYY-MM-DD') || '')
    history.replace({ search: queryParams.toString() })

    onClose()
  }, [onClose, history, search, currentItemDate])

  const handleBack = useCallback(() => {
    const queryParams = new URLSearchParams(search)

    queryParams.delete(FULLSCREEN_POST_KEY)
    queryParams.delete(FULLSCREEN_POST_ID_KEY)
    queryParams.set(LAST_OPENED_POST_DATE_KEY, dayjs(currentItemDate).format('YYYY-MM-DD') || '')
    history.replace({ search: queryParams.toString() })

    onClose()
  }, [onClose, history, search, currentItemDate])

  const useBackButtonListener = () => {
    useEffect(() => {
      const handlePopState = () => {
        handleBack()
      }

      window.addEventListener('popstate', handlePopState)

      return () => {
        // Cleanup the event listener when the component unmounts
        window.removeEventListener('popstate', handlePopState)
      }
    }, []) // Ensure the effect updates if the callback changes
  }

  return {
    useBackButtonListener,
    handleClose,
    handleBack,
  }
}
